import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaSaDepositosDeposito', {
    template: template,
    controller: NominaSaDepositosDepositoComponent,
    bindings: {
      data: '<',
      onChange: '&',
      onDelete: '&',
      onClose: '&',
    },
  })

function NominaSaDepositosDepositoComponent(NominaSaDepositosDeposito) {
  let $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.$onChanges = $onChanges
  $ctrl.actualizar = actualizar
  $ctrl.cerrar = cerrar
  $ctrl.eliminar = eliminar

  function $onInit() {
    $ctrl.actualizando = false
  }

  function $onChanges(changes) {
    if (changes.data) {
      $ctrl.idEmpresa = $ctrl.data.id_empresa
      $ctrl.idNomina = $ctrl.data.id_nomina
      $ctrl.indice = $ctrl.data.indice
      $ctrl.cuenta_sa = $ctrl.data.cuenta_sa
      $ctrl.data = {
        importe: $ctrl.data.importe,
        fecha_deposito: $ctrl.data.fecha_deposito,
      }
    }
  }

  function actualizar() {
    $ctrl.actualizando = true

    return NominaSaDepositosDeposito.put($ctrl.idEmpresa, $ctrl.idNomina, $ctrl.indice, $ctrl.data)
      .then(function () {
        $ctrl.onChange({$event: {data: $ctrl.data}})
      })
      .finally(function () {
        $ctrl.actualizando = false
      })
  }

  function cerrar() {
    $ctrl.onClose()
  }

  function eliminar() {
    $ctrl.actualizando = true

    return NominaSaDepositosDeposito.delete($ctrl.idEmpresa, $ctrl.idNomina, $ctrl.indice)
      .then(function () {
        $ctrl.onDelete()
      })
      .finally(function () {
        $ctrl.actualizando = true
      })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/sa/depositos/deposito/component.js